module.exports = __webpack_public_path__ + "static/media/fly0220.983b882a.webp";